import type {
  BridgePathType,
  BridgeSubmittedInfo,
} from "../../bridge";
import type { GetOneUsdActionId } from "../types";

function hasBridgeLeg(
  pathType: BridgePathType | undefined,
  action: GetOneUsdActionId,
): boolean {
  if (action === "bridge") return true;
  return (
    pathType === "bridge" ||
    pathType === "bridge-swap" ||
    pathType === "swap-bridge"
  );
}

function formatTransactionAmount(value: string): string {
  if (!value) return "";
  const [integer = "0", decimal = ""] = value.replace(/,/g, "").split(".");
  const normalizedInteger = integer.replace(/^0+(?=\d)/, "") || "0";
  const groupedInteger = normalizedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const trimmedDecimal = decimal.slice(0, 6).replace(/0+$/, "");
  return trimmedDecimal ? `${groupedInteger}.${trimmedDecimal}` : groupedInteger;
}

function getChainLabel(chainId: number): string {
  if (chainId === 56 || chainId === 97) return "BSC";
  if (chainId === 612044 || chainId === 612055 || chainId === 5555) {
    return "ONEchain";
  }
  return `Chain ${chainId}`;
}

export function getTransactionPendingLabel(
  info: BridgeSubmittedInfo,
  action: GetOneUsdActionId,
): "Bridging" | "Swapping" {
  return hasBridgeLeg(info.pathType, action) ? "Bridging" : "Swapping";
}

export function getTransactionSuccessNote(
  info: BridgeSubmittedInfo,
  action: GetOneUsdActionId,
): string {
  const amount = formatTransactionAmount(info.toAmount);
  if (hasBridgeLeg(info.pathType, action)) {
    const arriving = `arriving on ${getChainLabel(info.toToken.chainId)}`;
    return amount ? `${amount} ${arriving}` : arriving;
  }
  return amount ? `${amount} Swapped` : "Transaction completed";
}
